import { render, staticRenderFns } from "./list_search.vue?vue&type=template&id=ba04063e"
import script from "./list_search.vue?vue&type=script&lang=js"
export * from "./list_search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports